import { render, staticRenderFns } from "./PaymentInvoice.vue?vue&type=template&id=504b4c03"
import script from "./PaymentInvoice.vue?vue&type=script&lang=js"
export * from "./PaymentInvoice.vue?vue&type=script&lang=js"
import style0 from "./PaymentInvoice.vue?vue&type=style&index=0&id=504b4c03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports